module.exports = __webpack_public_path__ + "img/fountain_of_wonders_small.b469bb2d.png";